import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { UrlConstants } from "../../constants/url.constants";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DisclaimerDialogBodyComponent } from "../../../core/dashboard/disclaimer-dialog-body/disclaimer-dialog-body.component";
import { AuthService } from "../auth/auth.service";
import { map } from "rxjs/operators";
import { ApiUserConstants } from "../../constants/api-constants/api-user.constants";
import { SystemModuleSettingsService } from "../system-module-settings.service";
import { SystemSettingService } from "../system-setting/system-setting.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
export const ANONYMOUS_USER = {
    email: "",
    firstName: "",
    id: undefined,
    lastName: "",
    organisationApplications: [],
    organisations: [],
    userId: ""
};
let UserInformationService = class UserInformationService {
    http;
    router;
    appControllerService;
    systemModuleSettingsService;
    matDialog;
    authService;
    systemSettingsService;
    systemModulesLoaded$ = new BehaviorSubject(false);
    systemOrganisationsSubject = new BehaviorSubject(null);
    $systemOrganisations;
    systemModulesSubject = new BehaviorSubject([]);
    $systemModules;
    userInformationFetchedSubject = new BehaviorSubject(false);
    $userInformationFetched;
    authenticatedUserSubject = new BehaviorSubject(ANONYMOUS_USER);
    $authenticatedUser;
    $isAuthenticated;
    isUserInformationLoadedSubjectSubject = new BehaviorSubject(false);
    $isUserInformationLoaded = this.isUserInformationLoadedSubjectSubject.asObservable();
    constructor(http, router, appControllerService, systemModuleSettingsService, matDialog, authService, systemSettingsService) {
        this.http = http;
        this.router = router;
        this.appControllerService = appControllerService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.matDialog = matDialog;
        this.authService = authService;
        this.systemSettingsService = systemSettingsService;
        this.$systemOrganisations = this.systemOrganisationsSubject.asObservable();
        this.$systemModules = this.systemModulesSubject.asObservable();
        this.$systemModules = this.systemModulesSubject.asObservable();
        this.$userInformationFetched = this.userInformationFetchedSubject.asObservable();
        this.$authenticatedUser = this.authenticatedUserSubject.asObservable();
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.setUpListeners();
    }
    get userInformationFetchedValue() {
        return this.userInformationFetchedSubject.value;
    }
    getUserInformation() {
        this.getUserInformationRequest().subscribe({
            next: (userInformation) => {
                this.handleUserInformation(userInformation);
                this.systemModuleSettingsService.getSystemModuleSettingsRequest().subscribe(x => {
                    this.isUserInformationLoadedSubjectSubject.next(true);
                });
                this.systemSettingsService.loadSettings().then(data => {
                    if (this.systemSettingsService.isMaintenanceModeEnabled() && !this.systemSettingsService.getMaintenanceAcknowledged() && !this.router.url.includes("/logout")) {
                        this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
                    }
                });
            },
            error: (error) => {
                if (Object.prototype.hasOwnProperty.call(error, "error") && Object.prototype.hasOwnProperty.call(error.error, "error")
                    && Object.prototype.hasOwnProperty.call(error.error.error, "message")
                    && error.error.error.message === "User is not allowed to use AFLA Portal during testing") {
                    this.authService.logOutRedirect();
                }
                this.appControllerService.handleServerErrorMessage("user information", error, CRUDOperation.Get);
            }
        });
    }
    getModuleInformation(moduleId) {
        let foundModule;
        this.getSystemModules()?.forEach((module) => {
            if (module.id === moduleId) {
                foundModule = module;
                return;
            }
        });
        return foundModule;
    }
    getOrganisationInformation(OrganisationId) {
        let foundOrganisation = null;
        this.getOrganisations().forEach((organisation) => {
            if (organisation.id === OrganisationId) {
                foundOrganisation = organisation;
            }
        });
        return foundOrganisation;
    }
    getOrganisationId(moduleId) {
        const module = this.getModuleInformation(moduleId);
        if (module) {
            return module.organisationId;
        }
        else {
            return null;
        }
    }
    retrieveMyPortalApplications() {
        return this.http.get(`${ApiUserConstants.URL}/${ApiUserConstants.RETRIEVE_MY_PORTAL_APPLICATIONS_URL}`)
            .pipe(map(response => {
            return response;
        }));
    }
    hasOpenPortalApplications(moduleId) {
        const params = {
            moduleId
        };
        return this.http.get(`${ApiUserConstants.URL}/${ApiUserConstants.HAS_OPEN_PORTAL_APPLICATIONS}`, { params })
            .pipe(map(response => {
            return response;
        }));
    }
    isSysadminAdmin() {
        return this.authenticatedUserSubject.value?.isSysAdmin;
    }
    handleUserInformation(userInfo) {
        this.publishAuthUserValue(userInfo);
        this.publishSystemModules(userInfo);
        this.publishSystemOrganisations(userInfo);
        this.showDisclaimer();
    }
    getSystemModules() {
        return this.systemModulesSubject.value;
    }
    getUserInformationRequest() {
        const params = {
            $expand: `Organisations($expand=UserSystemRoles,Settings,Modules($expand=userModuleRoles)),OrganisationApplications`,
        };
        return this.http.get(UrlConstants.GET_MY_PORTAL_INFORMATION_URL, { params });
    }
    publishAuthUserValue(value) {
        this.authenticatedUserSubject.next(value);
        this.userInformationFetchedSubject.next(true);
    }
    setUpListeners() {
        this.setupAuthenticationListener();
    }
    showDisclaimer() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        this.matDialog.open(DisclaimerDialogBodyComponent, dialogConfig);
    }
    publishSystemModules(user) {
        if (user) {
            const modules = [];
            user.organisations.forEach(organisation => {
                modules.push(...organisation.modules);
            });
            this.systemModulesSubject.next(modules.sort((a, b) => 0 - (a.name > b.name ? -1 : 1)));
            if (modules.length > 0) {
                this.systemModulesLoaded$.next(true);
            }
            else {
                this.systemModulesLoaded$.next(false);
            }
        }
        else {
            this.systemModulesSubject.next([]);
        }
    }
    publishSystemOrganisations(user) {
        const organisations = [];
        if (user) {
            organisations.push(...user.organisations);
            this.systemOrganisationsSubject.next(organisations.sort((a, b) => 0 - (a.name > b.name ? -1 : 1)));
        }
        else {
            this.systemOrganisationsSubject.next([]);
        }
    }
    setupAuthenticationListener() {
        this.$isAuthenticated.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                this.getUserInformation();
            }
        });
    }
    getOrganisations() {
        return this.systemOrganisationsSubject.value;
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: Router },
        { type: AppControllerService },
        { type: SystemModuleSettingsService },
        { type: MatDialog },
        { type: AuthService },
        { type: SystemSettingService }
    ];
};
UserInformationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], UserInformationService);
export { UserInformationService };
